export default {
    url: '',
    template: `
        <courses-participations-list
            ng-if="vm.PrivilegeService.isCompanyAdmin() || vm.PrivilegeService.canManageExternalParticipations()"
            participation="vm.participation"
            sites="vm.sites"
            classifiers="vm.classifiers"
        />
    `, resolve: {
        sites (SiteResource) {
            return SiteResource.query({ externalParticipationsSites: true, pageSize: 0 }).$promise;
        },
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        }
    },
    controller (PrivilegeService, sites, classifiers) {
        this.PrivilegeService = PrivilegeService;
        this.sites = sites;
        this.classifiers = classifiers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/participations/list/index.js